import * as CONSTANTS from "./constants";

export const voteDataSelector = state => state.votedata;

const initialState = {
  opkomstJeugd: 0,
  opkomstRest: 0,
  stemmenJeugd: 0,
  stemmenRest: 0,
  stemmenTotaal: 0,
  kiesdeler: 0,
  zetelsJeugd: 0,
  zetelsRest: 0
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.UPDATE_VOTE_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/votedata/reducer.js